<template>
  <div class="Page Projects ProjectList">
    <h2 class="subtitle">
      Liste des projets -
      <router-link class="button is-small" :to="'/project/new'"
        >Ajouter</router-link
      >
    </h2>
    <hr />
    <PaginatedList
      :items="s_projects"
      :loading="loading"
      :per-page.sync="perPage"
    >
      <template slot="search">
        <div class="columns is-multiline" style="margin-bottom: 2em;">
          <div class="column is-one-third">
            <horiz-field>
              <label class="label" slot="label">Le nom contient :</label>
              <input type="text" class="input" v-model="query" />
            </horiz-field>
          </div>
          <div class="column is-one-third">
            <horiz-field>
              <label slot="label" class="label">dans les typologies :</label>
              <dropdown-multiple-search
                :label="'typologies'"
                :items="lists.typologies"
                :selected="advancedQuery.typologies"
                @selection="advancedQuery.typologies = $event"
              />
            </horiz-field>
          </div>
          <div class="column is-one-third">
            <horiz-field>
              <label slot="label" class="label">avec intervention de :</label>
              <dropdown-multiple-search
                :label="'partenaires'"
                :items="lists.partners"
                :selected="advancedQuery.partners"
                @selection="advancedQuery.partners = $event"
              />
            </horiz-field>
          </div>
          <div class="column is-one-third">
            <horiz-field>
              <label slot="label" class="label">localisé à :</label>
              <dropdown-multiple-search
                :label="'villes'"
                :items="lists.cities"
                :selected="advancedQuery.cities"
                :primitive="true"
                @selection="advancedQuery.cities = $event"
              />
            </horiz-field>
          </div>
          <div class="column is-one-third dimmed">
            <horiz-field>
              <label for="" slot="label" class="label">budget entre :</label>
              <div style="display: flex; width: 100%;">
                <input
                  type="text"
                  class="input"
                  style="max-width: 12ch;"
                  v-model="advancedQuery.bud.min"
                /><span class="is-size-7">&nbsp;et&nbsp;</span
                ><input
                  type="text"
                  style="max-width: 18ch;"
                  class="input"
                  v-model="advancedQuery.bud.max"
                />
              </div>
            </horiz-field>
          </div>
          <div class="column is-one-third dimmed">
            <horiz-field>
              <label for="" slot="label" class="label">surface entre :</label>
              <div style="display: flex;">
                <input
                  type="text"
                  class="input"
                  style="max-width: 12ch;"
                  v-model="advancedQuery.surf.min"
                /><span class="is-size-7">&nbsp;et&nbsp;</span
                ><input
                  type="text"
                  style="max-width: 18ch;"
                  class="input"
                  v-model="advancedQuery.bud.max"
                />
              </div>
            </horiz-field>
          </div>
          <div class="column is-full">
            <button
              class="button"
              :class="projects.length === f_projects.length ? 'dimmed' : ''"
              @click="basketAll"
            >
              Ajouter les projets filtrés au classeur
            </button>
          </div>
        </div>
      </template>

      <HelpMessage slot="list-message">
        <h3 slot="title">Liste des projets</h3>
        <p>
          Ce tableau <strong>liste les projets</strong>, indépendamment de leur
          degré de remplissage. <br />Vous pouvez les ordonner par ordre
          descendant ou ascendant en utilisant les petites flèches
          <i class="fa fa-caret-up"></i>
          <i class="fa fa-caret-down"></i> présentes près de certaines colonnes.
          <br />Il sera possible par la suite de les trier par
          <strong>typologie</strong>, <strong>programme</strong>, [...].
          <br />La miniature affichée n'est présente que dans ce tableau, et n'a
          pas d'effet sur les projets édités.
        </p>
      </HelpMessage>

      <template slot="table-headers">
        <td>
          En cours ?
          <updown
            :me="$options.sortmodes.BY_IN_PROGRESS"
            @dir="sort = $event"
            :sort="sort"
          />
        </td>
        <td style="max-width: 60px">Miniature</td>
        <td>
          Nom
          <updown
            :me="$options.sortmodes.BY_NAME"
            @dir="sort = $event"
            :sort="sort"
          />
        </td>
        <td>Typologies</td>
        <td>Programme</td>
        <td>Ville</td>
        <td>Actions</td>
      </template>

      <template
        slot="paginated-listItem"
        slot-scope="{ paginatedItem, paginatedItemIndex }"
      >
        <td style="text-align: center">
          <input
            type="checkbox"
            class="checkbox"
            :checked="paginatedItem.in_progress"
            @change="handleCheckbox(paginatedItemIndex, paginatedItem)"
          />
        </td>
        <td style="max-width: 60px">
          <api-picture :picture-id="paginatedItem.main_image" :lazy="false"></api-picture>
        </td>
        <td>
          <router-link :to="`/projects/view/${paginatedItem.uuid}`">{{
            paginatedItem.name
          }}</router-link>
        </td>
        <td style="max-width: 180px">
          {{ paginatedItem.typologies.map(t => t.name).join(", ") }}
        </td>
        <td style="max-width: 180px">
          {{ paginatedItem.programs.join(", ") }}
        </td>
        <td style="max-width: 120px">{{ paginatedItem.city }}</td>
        <td class="ProjectList__actions" style="max-width: 120px">
          <a class="is-small has-text-black" @click="basket(paginatedItem)"
            ><i class="fa fa-folder-open"></i> ajouter au classeur</a
          >
          <router-link
            class="is-small"
            :to="`/project/edit/${paginatedItem.uuid}`"
          >
            éditer&nbsp; <i class="fas fa-edit"></i> </router-link
          >&nbsp;
          <a
            class="is-small has-text-danger"
            @click="deleteProject(paginatedItem)"
            >supprimer</a
          >
        </td>
      </template>
    </PaginatedList>
  </div>
</template>

<script>
import { sortmodes, types as t } from "../../store/actions/projects";
import { types as kvt } from "../../store/actions/kv";
import { SCARY_MODAL } from "../../store/actions/actions";
import {
  deepGet,
  normalizeComparableValue,
  silence,
  extractUniqueById,
  toKeys
} from "../../util/func";
import HorizField from "../../components/Form/HorizField";
import Updown from "./../../components/Form/Updown";
import ApiPicture from "../../components/Form/ApiPicture";
import HelpMessage from "../../components/Form/HelpMessage";
import { types as basketActions } from "../../store/actions/basket";
import { types as basketMutations } from "../../store/mutations/basket";
import { ITEM_TYPES as basketItemTypes } from "../../store/mutations/basket";
import PaginatedList from "@/components/Layout/PaginatedList";
import DropdownMultipleSearch from "./DropdownMultipleSearch";

export default {
  name: "Projects",
  components: {
    DropdownMultipleSearch,
    HelpMessage,
    ApiPicture,
    PaginatedList,
    Updown,
    HorizField
  },
  data() {
    return {
      loading: false,
      query: "",
      lists: {
        typologies: [],
        partners: [],
        cities: []
      },
      advancedQuery: {
        typologies: [],
        partners: [],
        cities: [],
        bud: {
          min: 0,
          max: ""
        },
        surf: {
          min: 0,
          max: ""
        }
      },
      projects: [],
      perPage: 15,
      sort: {
        mode: sortmodes.BY_ID,
        dir: 0
      }
    };
  },
  sortmodes,
  computed: {
    f_projects() {
      let p = this.projects;
      if (this.query.toLowerCase().trim()) {
        p = p.filter(
          a =>
            a.name.toLowerCase().indexOf(this.query.toLowerCase().trim()) !== -1
        );
      }
      if (this.advancedQuery.typologies.length > 0) {
        p = p.filter(a =>
          a.typologies.some(
            t => this.advancedQuery.typologies.indexOf(t.id) !== -1
          )
        );
      }
      if (this.advancedQuery.partners.length > 0) {
        p = p.filter(a =>
          a.partners.some(t => this.advancedQuery.partners.indexOf(t.id) !== -1)
        );
      }
      if (this.advancedQuery.cities.length > 0) {
        p = p.filter(a => this.advancedQuery.cities.indexOf(a.city) !== -1);
      }
      return p;
    },
    s_projects() {
      const keys = toKeys(this.sort.mode);
      const co = this.sort.dir === 0 ? 1 : -1;
      return this.f_projects.slice(0).sort((b, a) => {
        return (
          (normalizeComparableValue(deepGet(b, keys)) <=
          normalizeComparableValue(deepGet(a, keys))
            ? -1
            : 1) * co
        );
      });
    }
  },
  methods: {
    deleteProject(project) {
      this.$root.$emit(SCARY_MODAL, {
        message: `Voulez-vous vraiment supprimer ${project.name} ?`,
        action: async () => {
          await this.$store.dispatch(t.DELETE_PROJECT, project.id);
          return this.fetch();
        }
      });
    },
    basketAll() {
      this.f_projects.forEach(this.basket);
      this.$store.commit(basketMutations.M_OPEN_BASKET);
    },
    basket(p) {
      this.$store.dispatch(basketActions.ADD_BASKET_ITEM, {
        item: p,
        type: basketItemTypes.PROJECT
      });
    },
    async handleCheckbox(index, project) {
      try {
        await this.$store.dispatch(t.TOGGLE_PROJECT_STATUS, project);
        this.projects[index].in_progress = !project.in_progress;
      } catch (e) {
        silence(e);
      }
    },
    async fetch() {
      this.loading = true;
      this.projects = await this.$store.dispatch(t.GET_PROJECTS);
      this.loading = false;
      this.lists.partners = extractUniqueById(
        this.projects.reduce((b, a) => b.concat(a.partners), [])
      );
      this.lists.cities = Object.keys(
        this.projects.reduce((acc, p) => {
          acc[p.city] = 1;
          return acc;
        }, {})
      );
      this.lists.typologies = await this.$store.dispatch(
        kvt.GET_KV,
        "typologies"
      );
    }
  },
  async mounted() {
    this.fetch();
  }
};
</script>

<style lang="scss">
.ProjectList {
  &__actions {
    a {
      display: inline-block;
      margin: 2px;
    }
  }
}
</style>
